import request from "@/utils/request";
// 登录验证
export async function loginCheck(params) {
    return request({
        url: "/Login/UserLogin",
        method: "post",
        data: params,
    });
}

// 退出登录
export async function UserLogout(params) {
    return request({
        url: "/Login/UserLogout",
        method: "post",
    });
}

// 重置密码
export async function ResetPsd(params) {
    return request({
        url: "/Login/ResetPsd",
        method: "post",
        data: params,
    });
}


// 获取手机验证码
export async function SendSmsCode(params) {
    return request({
        url: "/Login/SendSmsCode",
        method: "post",
        data: params,
    });
}

// 手机号码登录
export async function PhoneLogin(params) {
    return request({
        url: "/Login/PhoneLogin",
        method: "post",
        data: params,
    });
}